import { useAct } from 'FlowTaker/store'
import EmailToTarget from 'FlowBuilder/components/ActionViews/EmailToTarget/EmailToTarget'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'

export default function EmailToTargetAction({ actionId, surveyId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const context = useRenderContext({ actionId })
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})

  const handleSubmit = (data) => {
    return act.taker.completeAction({ actionId, actionParams: data })
  }
  function handleSkip() {
    return act.taker.skipAction({ actionId })
  }
  const onUpdateNoTarget = () => {
    return act.taker.updateNoTarget()
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <EmailToTarget
        action={action}
        onSubmit={handleSubmit}
        onSkip={handleSkip}
        onUpdateNoTarget={onUpdateNoTarget}
      />
    </>,
  }), [surveyId])

  return <div>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
